import React from 'react'
import { ExclamationCircle } from '../../svg/exclamation_circle'
import { withPrefix } from 'gatsby';

const TratamientoTransferencia = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Tratamiento y transferencia de tus datos personales
        </h2>
        <h3 className='font-family-terciary c-turquoise-0 tw-m-0 fw-6 tw-f-20 tw-f-20@lg tw-mb-4 tw-mb-4@lg'>
          Gracias por visitar nuestro sitio web.
        </h3>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          En Prima AFP nos preocupamos por la protección y privacidad de los datos personales 
          de nuestros usuarios. Por ello, garantizamos la absoluta confidencialidad de los 
          mismos y empleamos altos estándares de seguridad, conforme a lo establecido en 
          la Ley de Protección de Datos Personales - Ley N° 29733 y su Reglamento aprobado 
          por el Decreto Supremo N° 003-2013-JUS (“las normas de protección de datos personales”).
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          De acuerdo con las normas de protección de datos personales, en Prima AFP estamos 
          legalmente autorizados para usar tus datos personales, por ejemplo, sobre tu situación 
          personal, financiera y crediticia, con la finalidad de ejecutar la relación contractual que 
          mantienes con nosotros. También podemos usar y compartir tus datos personales con 
          autoridades y terceros autorizados por la ley, con la finalidad de cumplir con las 
          obligaciones señaladas en normas peruanas o internacionales aplicables a Prima AFP, 
          incluyendo las vinculadas al sistema de prevención de lavado de activos y financiamiento 
          del terrorismo y normas prudenciales.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Tus datos personales incluyen la información que nos hayas proporcionado 
          y aquellos datos personales a los que podamos acceder, de forma física, oral 
          o electrónica, a través de fuentes accesibles al público o de terceros.
        </p>
        <div
          className={`brad-4 bg-turquoise-1 tw-p-4 font-family-primary tw-f-16 tw-f-16@lg tw-mt-6`}
        >
          <div className={`flex`}>
            <div className={`tw-mr-2`}>
              <ExclamationCircle fill={'#04A6A2'} />
            </div>
            <div>
              <p>
                <strong>Recuerda que:</strong>
              </p>
              <p>
                Tú eres el dueño de tus datos. Por eso, para garantizarte una adecuada atención, 
                confiamos que la información proporcionada es veraz, exacta, completa y vigente, 
                y auténtica. Para ello deberás mantener actualizada tu información, sin perjuicio 
                que nosotros la actualicemos, validemos o complementemos a partir de fuentes 
                legítimas públicas, en cumplimiento del Principio de Calidad establecido en la 
                Ley de Protección de Datos Personales.
              </p>
            </div>
          </div>
        </div>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mt-4 tw-mt-4@lg tw-mb-4 tw-mb-4@lg'>
          La información que nos brindes también podrá ser transferida a Encargados 
          (son nuestros proveedores que realizan el tratamiento de datos personales por 
          encargo nuestro, como por ejemplo servicio de mensajería, envío de comunicaciones, 
          procesamiento de operaciones, etc.) ubicados en el Perú y en el extranjero, 
          los mismos que nos brindan un servicio particular. Puedes revisarlos{' '}
          <a
            className='c-orange-0 b underline'
            target='_blank'
            rel='noopener noreferrer'
            href={withPrefix('/politica-de-privacidad/#empresas-y-socios-comerciales')}
          >
            aquí.
          </a>
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-6 tw-mb-8@lg'>
          También podemos facilitar la información a organismos de la Administración Pública 
          y autoridades competentes si somos requeridos de hacerlo en virtud de obligaciones 
          establecidas en ley. En algunos casos, debemos también proporcionar su información 
          personal a las referidas entidades con objeto del desarrollo de un proceso legal, 
          judicial y/o administrativo, conforme a ley.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Tu información podrá ser conservada hasta diez años después de que finalice la 
          relación contractual con Prima AFP y será almacenada en el siguiente Banco de Datos:
        </p>
        <div className='table-0 w-100 tw-mb-4 tw-mb-4@lg'>
          <table className='w-100'>
            <thead className='bg-gray-6'>
              <tr>
                <th className='w-35 fw-6 tw-f-14 tw-f-14@lg f tw-pl-4 tw-pl-8@lg'>Código de Registro</th>
                <th className='w-35 fw-6 tw-f-14 tw-f-14@lg'>Titular del banco</th>
                <th className='w-30 fw-6 tw-f-14 tw-f-14@lg'>Denomiación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='fw-7 tw-py-5 tw-pl-4 tw-pl-8@lg'>RNPDP-PJP N°378</td>
                <td className='tw-py-5'>Prima AFP</td>
                <td className='tw-py-5'>Clientes</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          No te preocupes, tu información está segura con nosotros. Y para evitar la manipulación 
          indebida, pérdida, destrucción o acceso no autorizado a tus datos, hemos adoptado las 
          siguientes acciones:
        </p>
        <div className='c-gray--4 left'>
          <ul className={`w-100 bulletList-0 font-family-primary tw-f-16 tw-f-16@lg tw-mt-2`}>
            <li>
              Medidas técnicas y organizacionales para garantizar la seguridad y confidencialidad de tus datos.
            </li>
            <li>
              Solo personas autorizadas tienen acceso a ellos.
            </li>
            <li>
              Es posible que, para la ejecución de servicios, personas que no pertenecen a Prima AFP tengan 
              acceso a tu información y lo harán garantizando la seguridad y confidencialidad, y únicamente 
              para las finalidades que hayan sido debidamente autorizadas.
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default TratamientoTransferencia
